import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    TextField,
} from "@mui/material";
import * as APIModels from "../../../models";
import { FileService } from "../../../services/SubmissionService";
import { MatterService } from "../../../services/ClientService";
import { Endpoints } from "../../../helpers/Endpoints";

type TemplateCreateModalProps = {
    userId: string;
    organizationId: string;
    isOpen: boolean;
    /** close the modal with this  should be a setIsOpen(false); */
    handleClose: () => void;
};

type AddTemplate = APIModels.AddTemplateV2Request;

function TemplateCreateModal(params: TemplateCreateModalProps) {
    const [files, setfiles] = useState<
        { filename: string; size: number; file: File }[]
    >([]);
    const [note, setnote] = useState<string>();
    const [addTemplateRequest, setAddTemplateRequest] = useState<AddTemplate>({
        userID: params.userId,
        organizationID: params.organizationId,
    });
    const prefix = `${params.userId}/templates/`;

    useEffect(() => {
        setAddTemplateRequest({
            ...addTemplateRequest,
            notes: note,
        });
    }, [note]);

    const onFileUpload = async (event: React.FormEvent) => {
        event.preventDefault();
        const input = event.target as HTMLInputElement;

        if (!input.files?.length) {
            return;
        }
        const filInfo = [...(files ?? [])];

        for (let i = 0; i < input.files.length; i++) {
            const f = input.files[i];

            filInfo.push({ filename: f.name, size: f.size, file: f });
        }
        setfiles(filInfo);
    };

    return (
        <Dialog
            open={params.isOpen}
            onClose={params.handleClose}
            PaperProps={{
                component: "form",
                onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();

                    files.forEach(async (element) => {
                        await FileService.upload({
                            fileServiceUrl: Endpoints.FileManager ?? "",
                            file: element.file,
                            filename: prefix + element.filename,
                        });
                        const body: AddTemplate = {
                            ...addTemplateRequest,
                            filename: element.filename,
                        };
                        const result = await MatterService.addTemplate({
                            body,
                        });
                        console.log({ ...result });
                    });
                },
            }}
            onSubmit={() => console.log("")}
        >
            <DialogTitle>Create Template</DialogTitle>
            <DialogContent>
                <Stack direction="row">
                    <div>
                        <DialogContentText>Notes</DialogContentText>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="note"
                            name="note"
                            label="Add Notes to the Template"
                            type="text"
                            fullWidth
                            variant="standard"
                            onChange={(e) => setnote(e.currentTarget.value)}
                        />
                    </div>
                    <div className="fileupload btn btn-success waves-effect waves-light mb-3">
                        <input
                            type="file"
                            className="upload"
                            onChange={onFileUpload}
                            multiple
                        />
                        <span>Upload</span>
                    </div>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={params.handleClose}>Cancel</Button>
                <Button type="submit">Create Template</Button>
            </DialogActions>
        </Dialog>
    );
}

export default TemplateCreateModal;
